import { DragDropContext, DropResult, Droppable } from "react-beautiful-dnd";
import { isMobile, isTablet } from "react-device-detect";
import styled from "styled-components";

const SoundsWrapper = styled.div<{ colFlex: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

interface SoundboardProps {
    readonly handleReorderSound?: (result: DropResult) => void;
    readonly children: JSX.Element | JSX.Element[];
}
export default function Soundboard(props: SoundboardProps) {
    return (
        <DragDropContext onDragEnd={props.handleReorderSound}>
            <Droppable droppableId="soundboardSounds" direction={isMobile || isTablet ? "horizontal" : "vertical"}>
                {(provided) => (
                    <SoundsWrapper
                        colFlex={!(isMobile || isTablet)}
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {props.children}
                        {provided.placeholder}
                    </SoundsWrapper>
                )}
            </Droppable>
        </DragDropContext>
    );
}
